import PerfectScrollbar from "perfect-scrollbar";

const targets =  document.querySelectorAll('.ticket-panel-body');

targets.forEach(target => {
  var ps = new PerfectScrollbar(target);
});

// $(function() {
//   var ps = new PerfectScrollbar('.ticket-panel-body');
// });